// app/ningenie/components/PWAServiceWorkerRegister.tsx
// baby: Client component to register service worker

'use client'

import { useEffect } from 'react'
import { registerServiceWorker } from '../lib/service-worker'

const PWAServiceWorkerRegisterComponent = () => {
  useEffect(() => {
    // baby: register service worker on mount
    registerServiceWorker()
  }, [])

  return null
}

export const PWAServiceWorkerRegister = PWAServiceWorkerRegisterComponent

